module.exports = __webpack_public_path__ + "static/media/submit.c54ae46d.png";